export const environment = {
  production: false,
  apiURL: 'https://measuretest.axing.hu/api/index.php',
  keycloakAuthURL: 'https://auth24.axing.hu/',
  keycloakRealm: 'AxingKFT',
  keycloakClientID: 'measure_frontend_server',
  keycloakRedirectURI: 'https://measuretest.axing.hu'
};


